module.exports = __webpack_public_path__ + "img/res_download.f92ecd51.png";